import Competence from 'src/assets/js/Test/Competence.class'
import axios from 'axios'
import {get} from 'lodash'
const baseURL = '/api/test/'

export default class Answer {
	constructor (init = {}, forTour = false) {
		this.id = get(init, 'id') ? init.id : null
		this.test_question_id = get(init, 'test_question_id') ? init.test_question_id : null
		this.test_id = get(init, 'test_id') ? init.test_id : null
		this.answer_number = get(init, 'answer_number') ? init.answer_number : null
		this.answer = get(init, 'answer') ? init.answer : ''
		this.competences = get(init, 'competences') && Array.isArray(init.competences) ? Competence.createObjectFromArray(init.competences) : []
		this.is_correct = get(init, 'is_correct') ? forTour ? init.is_correct : Boolean(init.is_correct) : forTour ? 0 : false
		this.new_test = get(init, 'new_test') ? init.new_test : false
		this.isOpenTab = true
		this.forTour = !!forTour
	}

	static url = baseURL

	get findEmptyCompetence () {
		return this.competences.findIndex(item => !item.name)
	}

	deleteEmptyCompetence () {
		while (this.findEmptyCompetence >= 0) {
			this.competences.splice(this.findEmptyCompetence, 1)
		}
	}

	get formDataDelete () {
		const formData = new URLSearchParams()
		formData.append(`question[0][id]`, this.test_question_id)
		formData.append(`answer[0][0][id]`, this.id)
		formData.append(`answer[0][0][delete]`, 1)
		return formData
	}

	delete () {
		return axios.put(`${baseURL}${this.test_id}/question`, this.formDataDelete)
	}

	formData (formData, answerIndex, questionIndex, questionType) {
		if (this.id) {
			formData.append(`answer[${questionIndex}][${answerIndex}][id]`, this.id)
		}
		formData.append(`answer[${questionIndex}][${answerIndex}][answer]`, this.answer)
		formData.append(`answer[${questionIndex}][${answerIndex}][is_correct]`, this.correctDependQuestionType(questionType)) // todo поменять на true/false
		formData.append(`answer[${questionIndex}][${answerIndex}][answer_number]`, this.answer_number)
	}

	correctDependQuestionType (type) {
		if (type === 'choice') {
			return Number(this.is_correct)
		} else {
			return 1
		}
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/Test/Answer.class.js